import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DployFormControl, getFieldError, identityRecordOfFieldEditorOptions } from "@ploy-ui/form-fields";
import { commonButtonColors, commonButtonVariants, isButtonColor, isButtonVariant } from "./ButtonCommon";
import { apiResourceUrl, getIn } from "@ploy-lib/core";
import icons from "./Icons";
import { useAppLoad } from "../../appLoadContext";
import { useSearchParams } from "react-router-dom";
import { PendingButton } from "@ploy-ui/core";
import { useCallback, useState } from "react";
import { Box } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { useFormikContext } from 'formik';
import { defineMessages, useIntl } from "react-intl";
var GoToSblStatus;
(function (GoToSblStatus) {
    GoToSblStatus[GoToSblStatus["Failure"] = 0] = "Failure";
    GoToSblStatus[GoToSblStatus["Success"] = 1] = "Success";
    GoToSblStatus[GoToSblStatus["Completed"] = 2] = "Completed";
})(GoToSblStatus || (GoToSblStatus = {}));
const messages = defineMessages({
    sblInitError: {
        id: "template-form.go-to-sbl-button.sbl-init-error",
        defaultMessage: "An error occurred initiating SBL. Please try again later."
    }
});
export const GoToSblButton = ({ muiEndIcon, variant, color, size, action, fullWidth, margin, options: { style }, errorDisplay, disabled, buttonSize, className, field, form, label, ...props }) => {
    const appLoadData = useAppLoad();
    const [searchParams, _] = useSearchParams();
    const customerContext = searchParams.get("customerContext");
    const { submitForm } = useFormikContext();
    const intl = useIntl();
    const { value, name } = field;
    const { errors, touched } = form;
    const errorProps = getFieldError(errors, touched, field.name, errorDisplay);
    const error = getIn(form.errors, name);
    const buttonColor = isButtonColor(color) ? color : undefined;
    const buttonVariant = isButtonVariant(variant) ? variant : undefined;
    const [internalState, setInternalState] = useState({ loading: false, success: false, error: false });
    const onClick = useCallback(async (e) => {
        form.setFieldTouched(name, true);
        if (error)
            return;
        setInternalState({ loading: true, success: false, error: false });
        let goToSblUri = apiResourceUrl(`/GoToSbl/${appLoadData.applicationId}/`);
        if (customerContext) {
            goToSblUri += `?customerContext=${customerContext}`;
        }
        const response = await fetch(goToSblUri, { method: "GET" });
        if (!response.ok) {
            throw new Error("Error initiating SBL: Response from server is not OK");
        }
        const content = (await response.json());
        switch (content.Status) {
            case GoToSblStatus.Success: {
                window.open(content.RedirectUrl, "_parent");
                setInternalState({ loading: false, success: true });
                break;
            }
            case GoToSblStatus.Completed: {
                /*
                    * Submit the form if SBL is completed. This will cause a
                    * reevaluation of what form to present to the user.
                    */
                submitForm();
                setInternalState({ loading: false, success: true });
                break;
            }
            default: {
                console.error("Failed to initiate SBL.");
                setInternalState({ loading: false, success: false, error: true });
            }
        }
    }, [form, name, error, appLoadData.applicationId, customerContext, submitForm]);
    const alert = internalState.error
        ? {
            severity: "warning",
            message: intl.formatMessage(messages.sblInitError)
        }
        : errorProps?.error && errorProps.helperText
            ? { severity: "warning", message: errorProps.helperText }
            : internalState.success && value
                ? { severity: "info", message: value }
                : null;
    return (_jsxs(DployFormControl, { className: className, margin: margin, error: errorProps?.error || Boolean(internalState.error), fullWidth: fullWidth, children: [_jsx(PendingButton, { style: style, color: buttonColor, variant: buttonVariant, fullWidth: fullWidth, disabled: disabled || errorProps?.error, helperText: errorProps?.helperText, size: buttonSize || "large", endIcon: muiEndIcon && icons[muiEndIcon], success: internalState.success && !errorProps?.error, onClick: onClick, children: label }), alert && (_jsx(Box, { mt: 2, children: _jsx(Alert, { severity: alert.severity, children: alert.message }) }))] }));
};
GoToSblButton.displayName = "GoToSblButton";
export const EditorGoToSblButton = identityRecordOfFieldEditorOptions({
    GoToSblButton: {
        editableOptions: {
            variant: commonButtonVariants,
            color: commonButtonColors,
            muiEndIcons: Object.keys(icons)
        }
    }
});
//# sourceMappingURL=GoToSblButton.js.map